"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/cs-CZ.ts
var cs_CZ_exports = {};
__export(cs_CZ_exports, {
  AG_CHARTS_LOCALE_CS_CZ: () => AG_CHARTS_LOCALE_CS_CZ
});
module.exports = __toCommonJS(cs_CZ_exports);
var AG_CHARTS_LOCALE_CS_CZ = {
  ariaAnnounceChart: "graf, ${seriesCount}[number] s\xE9ri\xED",
  ariaAnnounceFlowProportionLink: "odkaz ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "uzel ${index} z ${count}, ${description}",
  ariaAnnounceGaugeChart: "graf m\u011B\u0159idla, ${caption}",
  ariaAnnounceHierarchyChart: "hierarchick\xFD graf, ${caption}",
  ariaAnnounceHierarchyDatum: "\xFArove\u0148 ${level}[number], ${count}[number] d\u011Bti, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Stiskn\u011Bte mezern\xEDk nebo Enter pro p\u0159epnut\xED viditelnosti",
  ariaLabelAddHorizontalLine: "P\u0159idat vodorovnou \u010D\xE1ru",
  ariaLabelAnnotationOptionsToolbar: "Mo\u017Enosti anotace",
  ariaLabelAnnotationSettingsDialog: "Nastaven\xED anotace",
  ariaLabelColorPicker: "V\xFDb\u011Br barev",
  ariaLabelFinancialCharts: "Finan\u010Dn\xED grafy",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, polo\u017Eka legendy ${index}[number] z ${count}[number]",
  ariaLabelLegendItemUnknown: "Nezn\xE1m\xE1 polo\u017Eka legendy",
  ariaLabelLegendPageNext: "Dal\u0161\xED str\xE1nka legendy",
  ariaLabelLegendPagePrevious: "P\u0159edchoz\xED str\xE1nka legendy",
  ariaLabelLegendPagination: "Str\xE1nkov\xE1n\xED legendy",
  ariaLabelNavigator: "Navig\xE1tor",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minim\xE1ln\xED",
  ariaLabelNavigatorRange: "Rozsah",
  ariaLabelRangesToolbar: "Rozsahy",
  ariaLabelSettingsTabBar: "Nastaven\xED",
  ariaLabelZoomToolbar: "P\u0159ibl\xED\u017Eit",
  ariaValuePanRange: "${min}[percent0to2dp] a\u017E ${max}[percent0to2dp]",
  contextMenuDownload: "St\xE1hnout",
  contextMenuPanToCursor: "Posunout sem",
  contextMenuToggleOtherSeries: "P\u0159epnout ostatn\xED s\xE9rie",
  contextMenuToggleSeriesVisibility: "P\u0159epnout viditelnost",
  contextMenuZoomToCursor: "P\u0159ibl\xED\u017Eit sem",
  dialogHeaderChannel: "Kan\xE1l",
  dialogHeaderDatePriceRange: "Datum a cena",
  dialogHeaderDateRange: "\u010Casov\xE9 obdob\xED",
  dialogHeaderFibonacciRange: "Fib Retracement",
  dialogHeaderLine: "\u010C\xE1ra",
  dialogHeaderPriceRange: "Cenov\xE9 rozmez\xED",
  dialogHeaderText: "Text",
  dialogInputAlign: "Zarovnat",
  dialogInputColorPicker: "Barva",
  dialogInputColorPickerAltText: "Barva textu",
  dialogInputExtendAbove: "Roz\u0161\xED\u0159it nad",
  dialogInputExtendBelow: "Roz\u0161\xED\u0159it dol\u016F",
  dialogInputExtendChannelEnd: "Roz\u0161\xED\u0159it konec kan\xE1lu",
  dialogInputExtendChannelStart: "Roz\u0161\xED\u0159it za\u010D\xE1tek kan\xE1lu",
  dialogInputExtendLeft: "Rozt\xE1hnout doleva",
  dialogInputExtendLineEnd: "Prodlu\u017Ete konec \u0159\xE1dku",
  dialogInputExtendLineStart: "Roz\u0161\xED\u0159it za\u010D\xE1tek \u010D\xE1ry",
  dialogInputExtendRight: "Roz\u0161\xED\u0159it doprava",
  dialogInputFibonacciBands: "P\xE1sma",
  dialogInputFibonacciBandsAltText: "Fibonacci p\xE1sma",
  dialogInputFillColorPicker: "V\xFDpl\u0148",
  dialogInputFillColorPickerAltText: "Barva v\xFDpln\u011B",
  dialogInputFontSize: "Velikost",
  dialogInputFontSizeAltText: "Velikost p\xEDsma",
  dialogInputLineStyle: "\u010C\xE1rkovan\xE1 \u010D\xE1ra",
  dialogInputPosition: "Um\xEDst\u011Bn\xED",
  dialogInputReverse: "Obr\xE1tit",
  dialogInputShowFill: "Zobrazit v\xFDpl\u0148",
  dialogInputStrokeWidth: "Tlou\u0161\u0165ka",
  dialogInputStrokeWidthAltText: "Tlou\u0161\u0165ka \u010D\xE1ry",
  iconAltTextAlignCenter: "Zarovnat doprost\u0159ed",
  iconAltTextAlignLeft: "Vlevo",
  iconAltTextAlignRight: "Vpravo",
  iconAltTextClose: "Zav\u0159\xEDt",
  iconAltTextLineStyleDashed: "Dlouh\xE9 poml\u010Dky",
  iconAltTextLineStyleDotted: "Kr\xE1tk\xE9 \u010D\xE1rkovan\xE9",
  iconAltTextLineStyleSolid: "Pln\xE1",
  iconAltTextPositionBottom: "Dole",
  iconAltTextPositionCenter: "St\u0159ed",
  iconAltTextPositionTop: "Nahoru",
  inputTextareaPlaceholder: "P\u0159idat text",
  measurerDateRangeBars: "${value}[number] pruhy",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Objem ${value}",
  overlayLoadingData: "Na\u010D\xEDt\xE1n\xED dat...",
  overlayNoData: "\u017D\xE1dn\xE1 data k zobrazen\xED",
  overlayNoVisibleSeries: "\u017D\xE1dn\xE1 viditeln\xE1 s\xE9rie",
  overlayUnsupportedBrowser: "Nepodporovan\xE1 verze prohl\xED\u017Ee\u010De. Pros\xEDm, aktualizujte si prohl\xED\u017Ee\u010D.",
  seriesHistogramTooltipCount: "${yName} (po\u010Det)",
  seriesHistogramTooltipFrequency: "Frekvence",
  seriesHistogramTooltipMean: "${yName} (pr\u016Fm\u011Br)",
  seriesHistogramTooltipSum: "${yName} (sou\u010Det)",
  toolbarAnnotationsArrow: "\u0160ipka",
  toolbarAnnotationsArrowDown: "\u0160ipka dol\u016F",
  toolbarAnnotationsArrowUp: "\u0160ipka nahoru",
  toolbarAnnotationsCallout: "Pozn\xE1mka pod \u010Darou",
  toolbarAnnotationsClearAll: "Vymazat v\u0161e",
  toolbarAnnotationsComment: "Koment\xE1\u0159",
  toolbarAnnotationsDatePriceRange: "Datum a cena",
  toolbarAnnotationsDateRange: "\u010Casov\xFD rozsah",
  toolbarAnnotationsDelete: "Smazat",
  toolbarAnnotationsDisjointChannel: "Odd\u011Blen\xFD kan\xE1l",
  toolbarAnnotationsDragHandle: "P\u0159et\xE1hn\u011Bte panel n\xE1stroj\u016F",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "V\xFDpo\u010Det Fibonacciho korekc\xED",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Nez\xE1visl\xFD na \u010Case",
  toolbarAnnotationsFillColor: "Barva v\xFDpln\u011B",
  toolbarAnnotationsHorizontalLine: "Horizont\xE1ln\xED \u010D\xE1ra",
  toolbarAnnotationsLineAnnotations: "Trendy linie",
  toolbarAnnotationsLineColor: "Barva \u010D\xE1ry",
  toolbarAnnotationsLineStrokeWidth: "\u0160\xED\u0159ka tahu \u010D\xE1ry",
  toolbarAnnotationsLineStyle: "Styl \u010D\xE1ry",
  toolbarAnnotationsLock: "Zamknout",
  toolbarAnnotationsMeasurerAnnotations: "M\u011B\u0159i\u010De",
  toolbarAnnotationsNote: "Pozn\xE1mka",
  toolbarAnnotationsParallelChannel: "Paraleln\xED kan\xE1l",
  toolbarAnnotationsPriceRange: "Cenov\xE9 rozp\u011Bt\xED",
  toolbarAnnotationsQuickDatePriceRange: "M\u011B\u0159it",
  toolbarAnnotationsSettings: "Nastaven\xED",
  toolbarAnnotationsShapeAnnotations: "\u0160ipky",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textov\xE9 pozn\xE1mky",
  toolbarAnnotationsTextColor: "Barva textu",
  toolbarAnnotationsTextSize: "Velikost textu",
  toolbarAnnotationsTrendLine: "Trend Line",
  toolbarAnnotationsUnlock: "Odemknout",
  toolbarAnnotationsVerticalLine: "Vertik\xE1ln\xED \u010D\xE1ra",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\u011Bs\xEDc",
  toolbarRange1Year: "1R",
  toolbarRange1YearAria: "1 rok",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 m\u011Bs\xEDce",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\u011Bs\xEDc\u016F",
  toolbarRangeAll: "V\u0161e",
  toolbarRangeAllAria: "V\u0161e",
  toolbarRangeYearToDate: "Rok do dne\u0161n\xEDho dne",
  toolbarRangeYearToDateAria: "Od za\u010D\xE1tku roku",
  toolbarSeriesTypeCandles: "Sv\xED\u010Dky",
  toolbarSeriesTypeDropdown: "Typ grafu",
  toolbarSeriesTypeHighLow: "V\xFD\u0161ka N\xEDzk\xE1",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Pr\u016Fsvitn\xE9 sv\xED\u010Dky",
  toolbarSeriesTypeLine: "\u010C\xE1ra",
  toolbarSeriesTypeLineWithMarkers: "\u010C\xE1ra s markery",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Krokov\xE1 \u010C\xE1ra",
  toolbarZoomPanEnd: "Posunout na konec",
  toolbarZoomPanLeft: "Posunout vlevo",
  toolbarZoomPanRight: "Posunout doprava",
  toolbarZoomPanStart: "Posunout na za\u010D\xE1tek",
  toolbarZoomReset: "Obnovit zoom",
  toolbarZoomZoomIn: "P\u0159ibl\xED\u017Eit",
  toolbarZoomZoomOut: "Odd\xE1lit",
  tooltipPaginationStatus: "${index}[number] z ${count}[number]"
};
//# sourceMappingURL=cs-CZ.cjs.js.map
